import { pxToRem } from './px-to-rem';
/**
 * Returns a CSS property declaration with a pxToRem conversion,
 * but only if the value is higher than 0.
 */
export const pxToRemCssProperty = (property, value = '') => {
    const number = parseInt(value, 10);
    if (Number.isNaN(number) || number === 0) {
        return null;
    }
    return `${property}: ${pxToRem(number)};`;
};
//# sourceMappingURL=px-to-rem-css-property.js.map